var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.653,
    height: 39.877,
    viewBox: "0 0 39.653 39.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_549",
    "data-name": "Groupe 549",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_211",
    "data-name": "Trac\\xE9 211",
    d: "M91.412,68.912v.7a31.923,31.923,0,0,0-16.371,0,28.062,28.062,0,0,0-4.158,1.458c-.208.1-.442.182-.65.286-.13.052-.286.13-.416.182h0a31.208,31.208,0,0,0-5.847,3.592,37.8,37.8,0,0,1-.52-5.388l-.052-1.9,1.663-.911a41.949,41.949,0,0,1,4.911-2.265c.26-.1.52-.182.806-.286a32.62,32.62,0,0,1,4.911-1.328,37.99,37.99,0,0,1,15.071,0A25.446,25.446,0,0,1,91.412,68.912Z",
    transform: "translate(-63.4 -62.3)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    "data-name": "Trac\\xE9 212",
    d: "M171.665,74.328l-.052,1.9a37.456,37.456,0,0,1-.52,5.388c-.052.286-.1.547-.156.833a35.467,35.467,0,0,1-1.3,4.946,39.729,39.729,0,0,1-2.261,5.31q-.39.781-.857,1.562a37.226,37.226,0,0,1-4.418,6.143,25.609,25.609,0,0,1-6-2.733,30.883,30.883,0,0,0,6.34-9.084,30.539,30.539,0,0,0,1.845-5.1,31.8,31.8,0,0,0,.961-5.518c.078-.859.1-1.744.1-2.629a32.607,32.607,0,0,0-.286-4.243,37.937,37.937,0,0,1,4.911,2.238Z",
    transform: "translate(-132.012 -68.809)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_213",
    "data-name": "Trac\\xE9 213",
    d: "M88.926,127.628c-.364-.26-.754-.521-1.117-.807-.13-.1-.234-.182-.364-.286-.39-.312-.78-.625-1.169-.963-.156-.13-.286-.26-.442-.391-.416-.364-.806-.755-1.2-1.145a30.882,30.882,0,0,1-6.34-9.084s.26.729.286.729c.572-.755,3.82-2.265,4.807-2.421a23.839,23.839,0,0,0,5.509,7.5,26.237,26.237,0,0,0,5.717-7.913,25.242,25.242,0,0,0,1.767-5.05,26.161,26.161,0,0,0-14.967,0,25.326,25.326,0,0,0-4.963,2.082h0a26.282,26.282,0,0,0-5.353,3.878,36.6,36.6,0,0,0,2.261,5.31q.39.781.857,1.562a37.226,37.226,0,0,0,4.417,6.143,39.237,39.237,0,0,0,3.612,3.592c.208.182.442.364.65.547a34.481,34.481,0,0,0,4.392,3.124l1.611.989,1.637-.989a34.675,34.675,0,0,0,4.391-3.15,29.786,29.786,0,0,1-6-3.254Z",
    transform: "translate(-69.099 -95.143)",
    fill: "#39499b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/miniLogo.a5f9e8b906a67f1423afbd94d2cc593a.svg";
export { ForwardRef as ReactComponent };